var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-form',{ref:"topData",attrs:{"options":_vm.options,"rules":_vm.rules,"disabled":!_vm.canEdit,"label-width":"100px"},on:{"input":_vm.handleChange},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }